import React, { Fragment } from "react";
import PagesHeading from "../pages-heding/PagesHeading";
import GrivenceContent from "../grivence/grivencepage"; // ✅ rename properly

const GrivencePage = (props) => {
  return (
    <Fragment>
      <PagesHeading page_title={props.page_title} />

      <GrivenceContent /> {/* ✅ Correct component usage */}
    </Fragment>
  );
};

export default GrivencePage; // ✅ correct export